import{purry as e}from"./purry-DH9cw9sy.js";function t(...t){return e(n,t)}const n=(e,{min:t,max:n})=>t!==void 0&&e<t?t:n!==void 0&&e>n?n:e;export{t as clamp};
//# sourceMappingURL=clamp-DSPiOOFS.js.map